/**
 * Initialize the project Swiper instance.
 */
export function initProjectSwiper() {
  // Handle the project container which doesn't use .swiper-container class
  const projectContainer = document.querySelector('.project-container');

  if (projectContainer && window.Swiper) {
    const projectSwiper = new window.Swiper(projectContainer, {
      // modules are already configured in app.js via Swiper.use()
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
      },
    });

    projectContainer.addEventListener('mouseenter', () => {
      projectSwiper.autoplay.stop();
    });

    projectContainer.addEventListener('mouseleave', () => {
      projectSwiper.autoplay.start();
    });
  }
}